import { Text } from "@chakra-ui/react";
import FormPessoaFisicaOuJuridica from "components/FormPessoaFisicaOuJuridica/index";
import useCliente from "core/features/cliente/hooks/useCliente";
import { ClienteDetalheResponse } from "core/features/cliente/typings";
import { useSaveCliente } from "features/cliente/hooks";
import { PessoaTipo } from "features/pessoas/typings";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import history from "infra/helpers/history";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useLoading } from "ui/components/GlobalLoading";

function DadosCadastrais({
  onSaved,
  id,
}: {
  onSaved: (id: string) => void;
  id?: string;
}) {
  const { data, isLoading, isFetching } = useCliente(id);

  const { mutate: handleSave, isLoading: isLoadingSave } = useSaveCliente(id);

  const { control, handleSubmit, reset, watch, setValue } =
    useForm<ClienteDetalheResponse>({
      defaultValues: {
        pessoaTipo: PessoaTipo.Juridica,
        ativo: true,
      },
    });

  const _handleSave = (values: ClienteDetalheResponse) => {
    handleSave(
      { id, ...values },
      {
        onError: (err) => {
          showErrorAxios(err);
        },
        onSuccess: ({ data }) => {
          showSuccess();
          onSaved(data.clienteId);
        },
      }
    );
  };

  const isEdit = !!id;

  const form = watch();

  useEffect(() => {
    if (data) {
      reset(data);
    }
  }, [data, reset]);

  useLoading(isLoading || isFetching);

  return (
    <>
      <Text fontSize={"18px"} fontWeight={"bold"} mb="32px">
        Dados cadastrais
      </Text>

      <FormPessoaFisicaOuJuridica
        control={control}
        form={form}
        isEdit={isEdit}
        isLoadingSave={isLoadingSave}
        onSubmit={handleSubmit(_handleSave)}
        showActive
        onCancel={() => history.push("/cadastros/clientes")}
        requiredEmail
        setField={setValue}
      />
    </>
  );
}

export default DadosCadastrais;
